import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import SvgIcon from "@mui/material/SvgIcon";

import {featureInterface} from "../../../../interfaces/featureInterface";
import {GroheVehicleIcon} from "../../../common/icons";


const ShopFeatureShipping = (props) => {

  const {feature, fabricatorSettings} = props;

  return (
    <div className="shop-feature__shipping">
      <SvgIcon>
        <GroheVehicleIcon/>
      </SvgIcon>
      <span className="shop-feature__shipping-text">
        <FormattedMessage id={feature.dbFeature.shippingCost ? "shop.feature.shipping.cost" : "shop.feature.shipping.free"}/>
        {feature.dbFeature.shippingCost
          ? " " + fabricatorSettings.currencySign + feature.dbFeature.shippingCost
          : null}
      </span>
    </div>
  )
};

ShopFeatureShipping.propTypes = {
  feature: PropTypes.shape(featureInterface)
}

const mapStateToProps = (store) => {
  const {settings} = store.fabricatorState;

  return {
    fabricatorSettings: settings,
  };
};

export default connect(mapStateToProps)(ShopFeatureShipping)
